import {
  Square01,
  Square02,
  Square03,
  Square04,
  Square05,
  Square06,
  Square07,
  Square08,
  Square09,
  Square10,
} from "./squares";

export const DEFAULT_SQUARE_WIDTH = 1080;
export const DEFAULT_SQUARE_HEIGHT = 1350;

export default function SquareShape({
  size,
  variantColor,
  shape,
  imageUrl,
  logoSrc = "",
  primaryText,
  secondaryText,
  callText,
  positions,
  x_axis = 50,
}) {
  switch (shape) {
    case 1:
    default:
      return (
        <Square01
          size={size}
          variantColor={variantColor}
          imageUrl={imageUrl}
          logoSrc={logoSrc}
          primaryText={primaryText}
          secondaryText={secondaryText}
          callText={callText}
          positions={positions}
          x_axis={x_axis}
        />
      );
    case 2:
      return (
        <Square02
          size={size}
          variantColor={variantColor}
          imageUrl={imageUrl}
          logoSrc={logoSrc}
          primaryText={primaryText}
          secondaryText={secondaryText}
          callText={callText}
          positions={positions}
          x_axis={x_axis}
        />
      );
    case 3:
      return (
        <Square03
          size={size}
          variantColor={variantColor}
          imageUrl={imageUrl}
          logoSrc={logoSrc}
          primaryText={primaryText}
          secondaryText={secondaryText}
          callText={callText}
          positions={positions}
          x_axis={x_axis}
        />
      );
    case 4:
      return (
        <Square04
          size={size}
          variantColor={variantColor}
          imageUrl={imageUrl}
          logoSrc={logoSrc}
          primaryText={primaryText}
          secondaryText={secondaryText}
          callText={callText}
          positions={positions}
          x_axis={x_axis}
        />
      );
    case 5:
      return (
        <Square05
          size={size}
          variantColor={variantColor}
          imageUrl={imageUrl}
          logoSrc={logoSrc}
          primaryText={primaryText}
          secondaryText={secondaryText}
          callText={callText}
          positions={positions}
          x_axis={x_axis}
        />
      );
    case 6:
      return (
        <Square06
          size={size}
          variantColor={variantColor}
          imageUrl={imageUrl}
          logoSrc={logoSrc}
          primaryText={primaryText}
          secondaryText={secondaryText}
          callText={callText}
          positions={positions}
          x_axis={x_axis}
        />
      );
    case 7:
      return (
        <Square07
          size={size}
          variantColor={variantColor}
          imageUrl={imageUrl}
          logoSrc={logoSrc}
          primaryText={primaryText}
          secondaryText={secondaryText}
          callText={callText}
          positions={positions}
          x_axis={x_axis}
        />
      );
    case 8:
      return (
        <Square08
          size={size}
          variantColor={variantColor}
          imageUrl={imageUrl}
          logoSrc={logoSrc}
          primaryText={primaryText}
          secondaryText={secondaryText}
          callText={callText}
          positions={positions}
          x_axis={x_axis}
        />
      );
    case 9:
      return (
        <Square09
          size={size}
          variantColor={variantColor}
          imageUrl={imageUrl}
          logoSrc={logoSrc}
          primaryText={primaryText}
          secondaryText={secondaryText}
          callText={callText}
          positions={positions}
          x_axis={x_axis}
        />
      );
    case 10:
      return (
        <Square10
          size={size}
          variantColor={variantColor}
          imageUrl={imageUrl}
          logoSrc={logoSrc}
          primaryText={primaryText}
          secondaryText={secondaryText}
          callText={callText}
          positions={positions}
          x_axis={x_axis}
        />
      );
  }
}
